import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.ts'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const setTokens = useAuthStore((s) => s.setTokens)

  useEffect(() => {
    const accessToken = searchParams.get('accessToken')
    const refreshToken = searchParams.get('refreshToken')
    const userId = searchParams.get('userId')
    const email = searchParams.get('email')
    const name = searchParams.get('name')
    const role = searchParams.get('role')

    if (accessToken && refreshToken && userId && email && name && role) {
      setTokens(accessToken, refreshToken, { id: userId, email, name, role })
      navigate('/dashboard', { replace: true })
    } else {
      navigate('/login?error=m365_error', { replace: true })
    }
  }, [searchParams, setTokens, navigate])

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-2 border-brand-500 border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-sm text-gray-500">Anmeldung wird abgeschlossen…</p>
      </div>
    </div>
  )
}
